import { create } from "zustand";
import { send_request, send_request_optional_auth } from "../../utils/Request";

const useTaskQueueStore = create((set) => ({
  taskQueueEventsBySessionId: {},

  setTaskQueueEvent: (chatSessionId, queueEvent) => {
    if (!queueEvent || !chatSessionId) return;
    set((s) => ({
      taskQueueEventsBySessionId: {
        ...s.taskQueueEventsBySessionId,
        [chatSessionId]: queueEvent,
      },
    }));
  },

  getSessionTaskQueue: async (chatSessionId, clientId) => {
    return send_request(
      `ai-service/private/ai/agent/session/${chatSessionId}/task-queue`,
      "",
      { clientId },
      "GET"
    );
  },

  getSessionTaskQueueHistory: async (chatSessionId, clientId) => {
    return send_request(
      `ai-service/private/ai/agent/session/${chatSessionId}/task-queues`,
      "",
      { clientId },
      "GET"
    );
  },

  applySessionTaskQueueAction: async (chatSessionId, payload = {}) => {
    return send_request(
      `ai-service/private/ai/agent/session/${chatSessionId}/task-queue/action`,
      payload,
      {},
      "POST"
    );
  },

  getPublicTaskQueue: async (publicSessionToken, payload = {}) => {
    try {
      return await send_request_optional_auth(
        `ai-service/private/ai/agent/public-chat/session/${publicSessionToken}/task-queue`,
        payload,
        {},
        "POST"
      );
    } catch (e) {
      return e;
    }
  },

  applyPublicTaskQueueAction: async (publicSessionToken, payload = {}) => {
    try {
      return await send_request_optional_auth(
        `ai-service/private/ai/agent/public-chat/session/${publicSessionToken}/task-queue/action`,
        payload,
        {},
        "POST"
      );
    } catch (e) {
      return e;
    }
  },
}));

export default useTaskQueueStore;
